import React from "react";
import { Col, Form, Row } from "react-bootstrap";

const OfficeInformation = ({ OfficeInformationData }) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Office Information</span>

      <Row className="mb-3 gx-sm-3 gx-2">
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Office Name </Form.Label>
            <div>{OfficeInformationData?.officeInformation?.name || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="">
            <Form.Label className="fw-bold">Occupation Name</Form.Label>
            <div>
              {OfficeInformationData?.officeInformation?.occupation || "-"}
            </div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Department</Form.Label>
            <div>
              {OfficeInformationData?.officeInformation?.department || "-"}
            </div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Office address line 1</Form.Label>
            <div>{OfficeInformationData?.officeInformation?.line1 || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="">
            <Form.Label className="fw-bold">Office address line 2</Form.Label>
            <div>{OfficeInformationData?.officeInformation?.line2 || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Office mobile no</Form.Label>
            <div>
              {OfficeInformationData?.officeInformation?.phoneNumber || "-"}
            </div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Tel number(s):</Form.Label>
            <div>
              {OfficeInformationData?.officeInformation?.telPhoneNumber || "-"}
            </div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Website:</Form.Label>
            <div>
              {OfficeInformationData?.officeInformation?.websiteLink || "-"}
            </div>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default OfficeInformation;
